import { FieldDefinition } from '../../00_modules/core/product/FieldDefinition';
import { GroupedField, PageField } from '../../00_modules/core/product/GroupedField';

export class UpdateField {
    static readonly type = '[Fields] Update One';

    constructor(public fieldDefinition: FieldDefinition) {}
}

export class UpdateFields {
    static readonly type = '[Fields] Update Many';

    constructor(public fieldDefinitions: FieldDefinition[]) {}
}

export class SetSectionVisibility {
    static readonly type = '[Fields] Set Section Visibility';

    constructor(public groupedField: GroupedField) {}
}

export class SetPageVisibility {
    static readonly type = '[Fields] Set Page Visibility';

    constructor(public pageField: PageField) {}
}
